import { Box, Grommet } from 'grommet'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 auto;
  padding-top: 82px;
  position: relative;
  width: 100%;
`

export const NormalizedContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
`

type NormalizedWrapperProps = {
  marginTop?: string
  marginBottom?: string
  zIndex?: number
  paddingValue?: number
}

export const NormalizedWrapper = styled.div<NormalizedWrapperProps>`
  ${({ theme, marginTop, marginBottom, paddingValue, zIndex }) => css`
    margin: ${marginTop || 0} auto ${marginBottom || 0} auto;
    max-width: ${theme.maxWidth[6]}px;
    width: 100%;
    z-index: ${zIndex || 'auto'};

    ${theme.below.laptopL`
      max-width: ${theme.maxWidth[3]}px;
    `}

    ${theme.below.laptop`
      padding: 0 ${paddingValue || theme.spaces[2]}px;
    `}
  `}
`

export const ThemeProvider = styled(Grommet)`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`

export const PageContent = styled(Box)`
  overflow: hidden;

  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    width: 100%;

    & > div:not(:first-child) {
      margin-top: ${theme.newSpaces.xl10}px;
    }

    ${theme.below.laptop`
      & > div:not(:first-child) {
        margin-top: ${theme.newSpaces.xl3}px;
      }
    `}

    ${theme.below.mobileXL`
      & > div:not(:first-child) {
        margin-top: ${theme.newSpaces.xl2}px;
      }
    `}

    .decorative-item {
      ${theme.below.laptop`
        display: none;
      `}
    }
  `}
`

export const ImageContainer = styled(Box)`
  height: 100%;
  position: relative;
  width: 100%;
`
